import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@apollo/client';
import { RESEND_VERIFICATION_EMAIL } from '~/services/auth';
import { publicClient } from '~/services';

interface VerificationDialogProps {
  email: string;
  onClose: () => void;
}

export const VerificationDialog = ({
  email,
  onClose,
}: VerificationDialogProps) => {
  const [t] = useTranslation('login');
  const [resend, { loading, data }] = useMutation(RESEND_VERIFICATION_EMAIL, {
    client: publicClient,
  });

  return createPortal(
    <dialog className="modal" open onClose={onClose}>
      <div className="modal-box w-96 max-w-full text-center">
        <div className="mb-2 text-2xl">✉️</div>
        <h3 className="text-lg font-bold">{t('verify_email_title')}</h3>
        <p className="text-base-content/70 text-sm">
          {t('verify_email_message')}
        </p>
        <div className="mt-4 space-y-1">
          <p className="text-base-content/60 text-sm">
            {t('verify_email_instructions', { email })}
          </p>
          <p className="text-base-content/60 text-sm">
            {t('verify_email_spam_notice')}
          </p>
        </div>

        <div className="modal-action flex flex-col items-stretch gap-2">
          <button
            className="btn btn-primary w-full"
            onClick={async () => {
              try {
                await resend({
                  variables: {
                    data: { email },
                  },
                });
              } catch (_) {}
            }}
            disabled={loading}
          >
            {loading ? t('sending') : t('resend_verification_email')}
          </button>
          {data?.response?.message && (
            <span className="text-base-content/60 text-xs">
              {data.response.message}
            </span>
          )}
          <button className="btn btn-ghost w-full" onClick={onClose}>
            {t('got_it')}
          </button>
        </div>
      </div>
      <form method="dialog" className="modal-backdrop" onClick={onClose}>
        <button>close</button>
      </form>
    </dialog>,
    document.body,
  );
};
